export default __webpack_public_path__ + "static/media/alert.985b1c04.mp3";